import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Nav from '../Nav';
import MobileNav from '../MobileNav';
import { useDispatch } from 'react-redux';
import { useSelector } from "react-redux";
import { auth } from '../../config/firebase';
import { loginActions } from '../../store/loginSlice';
import { jobActions } from '../../store/jobSlice';
import { Link } from 'react-router-dom';
import Loader from '../Loader';
import { Helmet } from 'react-helmet';
import classes from './DetailedJob.module.css';

const DetailedJob = () => {
  const dispatch = useDispatch();
  const jobList = useSelector(state => state?.job?.items);

  const [loading, setLoading] = useState(false);
  const [jobId, setJobId] = useState('');
  const [jobItem, setJobItem] = useState({});

  useEffect(() => {
    setLoading(true);

    auth.onAuthStateChanged((user) => {
      if (user) {
        dispatch(loginActions.login());
      }
    });

    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [dispatch]);


  useState(() => {
    const fetchData = async () => {
      const response = await fetch('https://codinguniverse-20c51-default-rtdb.firebaseio.com/jobs.json');
      const data = await response.json();
      dispatch(jobActions.replace(data.items));
    }
    fetchData();
  }, []);
  
  useEffect(()=>{
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Optionally, you can use 'auto' or 'instant' for different scrolling behavior
    });
  },[])
  
  const params = useParams();
  useEffect(() => {
    console.log("params updates");
    setJobId(params?.jobId?.substring(1));
  }, [params]);

  useEffect(() => {
    const requiredJob = jobList.filter((job) => {
      return job.id === jobId;
    });
    setJobItem(requiredJob[0]);

  }, [jobList, jobId]);

  console.log(jobItem);

  return (
    <>
      <Helmet>
        <title>Coding Universe Get Hired </title>
        {/* <meta property="og:description" content={}/> */}
        <meta property="og:image" content={jobItem?.logo}/>
        {/* <meta property="og:url" content={} /> */}
        <meta property="og:type" content="website" />
      </Helmet>

      {loading && <Loader></Loader>}

      <Nav></Nav>
      <MobileNav></MobileNav>

      <div className={classes.detailedJob}>

        <div className={classes.companyDetails}>

          <div className={classes.logo}>
            <img src={jobItem?.logo} alt="" />
          </div>

          <div className={classes.aboutCompany}>
            <h2>{jobItem?.company}</h2>
            {jobItem?.companyUrl && <Link to={jobItem?.companyUrl}> <i class="fa-solid fa-globe"></i>{jobItem?.companyUrl}</Link>}
          </div>

        </div>

        <div className={classes.jobDescription}>
          <div className={classes.left}>
            <h3>{jobItem?.role}</h3>

            {jobItem?.experience && <span><i class="fa-solid fa-briefcase"></i>{jobItem?.experience}</span>}

            {jobItem?.location && <span><i class="fa-solid fa-location-dot"></i>{jobItem?.location}</span>}

            {jobItem?.salary && <span><i class="fa-solid fa-wallet"></i>{jobItem?.salary}</span>}

            {jobItem?.deadline && <span><i class="fa-solid fa-calendar-days"></i>{jobItem?.deadline}</span>}

            {jobItem?.url && <Link to={jobItem?.url}>Apply</Link>}

          </div>

          {jobItem?.description && <div className={classes.right}>
            {jobItem?.description && <h3>Description:</h3>}
            {jobItem?.description && <p>{jobItem?.description}</p>}

            {jobItem?.requirements && <h3>Requirements:</h3>}
            {jobItem?.requirements && <p>{jobItem?.requirements}</p>}
          </div>}
        </div>

      </div>
    </>
  )
}

export default DetailedJob;
